import React from "react";
import { useLang } from "../LanguageContext";
import { useSettings } from "../SettingsContext";
import { useEditMode } from "../EditModeContext";
import EditableI18n from "./EditableI18n";

export default function MarqueeStrip() {
  const { t, lang } = useLang();
  const { settings } = useSettings();
  const { editMode, isAdmin } = useEditMode();
  const editing = editMode && isAdmin;
  const n = t.marquee.length;
  // Resolve admin overrides so all three loop copies stay in sync
  const resolved = t.marquee.map((label, i) => {
    const v = settings[`txt_marquee_${i}_${lang === "fr" ? "fr" : "en"}`];
    return (typeof v === "string" && v.trim()) || label;
  });
  const items = [...resolved, ...resolved, ...resolved];
  return (
    <div
      data-testid="marquee-strip"
      className="relative border-y border-border bg-secondary/40 py-5 overflow-hidden"
    >
      <div className="flex gap-16 whitespace-nowrap qw-marquee" style={editing ? { animationPlayState: "paused" } : undefined}>
        {items.map((label, i) => (
          <span
            key={i}
            className="font-serif text-2xl md:text-3xl text-primary/90 tracking-wide italic"
          >
            {i < n ? <EditableI18n k={`marquee.${i}`} label={`Marquee word ${i + 1}`} /> : label}
            {" "}<span className="mx-6 text-primary/40">✦</span>
          </span>
        ))}
      </div>
      <style>{`
        .qw-marquee { animation: qw-marquee-anim 38s linear infinite; }
        @keyframes qw-marquee-anim {
          from { transform: translateX(0); }
          to { transform: translateX(-33.333%); }
        }
      `}</style>
    </div>
  );
}
